import { ref } from 'vue';

export const useModal = () => {
  const isOpen = ref(false);
  const toggleModal = (value: boolean) => {
    isOpen.value = value;
  };
  return {
    toggleModal,
    isOpen,
  };
};

